import { useState } from "react";
import classnames from "classnames";
import CustomIcon from "../../../core/CustomIcon/CustomIcon";
import classes from "../Banner.module.scss";

const ServiceBanner = ({
  image,
  title,
  className,
  clickHandler = () => {
    console.error("Provide the clickHandler property");
  },
}) => {
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const style = {
    container: {
      backgroundColor: isHover ? "#00235C" : "#00BAF2",
    },
    text: {
      color: "#FFFFFF",
    },
  };
  return (
    <div
      style={style.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={classnames(className, classes.channelContainer)}
      onClick={clickHandler}
    >
      <div
        className={classnames("center")}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "12px",
        }}
      >
        <CustomIcon
          src={image}
          alt={title}
          title={title}
          iconHeight={33}
          iconWidth={33}
          style={{
            backgroundColor: "#FFFFFF",
            width: "80px",
            height: "80px",
            borderRadius: "100px",
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "12px",
          }}
        >
          <span style={style.text} className={classes.text}>
            {title}
          </span>
        </div>
      </div>
    </div>
  );
};
export default ServiceBanner;
